'use client';

import { useState } from 'react';
import clsx from 'clsx';
import { Eye, EyeClosed } from 'lucide-react';

type FormInputProps = {
    id: string;
    name: string;
    placeholder?: string;
    type?: 'text' | 'email' | 'password';
    value?: string;
    maxLength?: number;
    inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
    autoComplete?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    autoFocus?: boolean;
};

export default function FormInput({
    id,
    name,
    placeholder = '',
    type = 'text',
    value,
    maxLength = 200,
    inputMode,
    autoComplete = 'off',
    onChange,
    className,
    autoFocus,
}: FormInputProps) {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const isPassword = type === 'password';
    const inputType = isPassword ? (isPasswordVisible ? 'text' : 'password') : type;

    const baseClass = `
    font-notojp font-medium text-base text-color-base tracking-widest leading-normal
    bg-color-inputform-g-bg
    border border-color-white-base
    focus:outline-none focus:border-color-inputform-selected focus:bg-color-white-base
    autofill:shadow-[inset_0_0_0px_1000px_#F1F1F1]
    w-full px-4 block
    placeholder:text-sm
    appearance-none
  `;

    return (
        <div className="flex w-full relative">
            <input
                type={inputType}
                id={id}
                name={name}
                inputMode={isPassword ? undefined : inputMode}
                maxLength={maxLength}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                autoComplete={autoComplete}
                autoFocus={autoFocus}
                className={clsx(baseClass, className)}
            />
            {isPassword && (
                <button
                    type="button"
                    onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                    className="absolute right-3 top-1/2 -translate-y-1/2"
                >
                    {isPasswordVisible ? (
                        <EyeClosed strokeWidth={1.75} size={25} className="text-color-inputform-g-placeholder" />
                    ) : (
                        <Eye strokeWidth={1.75} size={25} className="text-color-base" />
                    )}
                </button>
            )}
        </div>
    );
}
